import { AvailableReadProviders } from '@ankr.com/provider';

import { isProd } from 'modules/common/utils/isProd';

export const getEthReadProviderID = () => {
  if (isProd()) {
    return AvailableReadProviders.ethMainnet;
  }

  return AvailableReadProviders.ethHolesky;
};
